// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function ListArrowDownRight(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "ListArrowDownRight" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M21 5H3V7H21V5Z", fill: "currentColor" }),
            React.createElement("path", { d: "M21 9H14V11H21V9Z", fill: "currentColor" }),
            React.createElement("path", { d: "M14 13H21V15H14V13Z", fill: "currentColor" }),
            React.createElement("path", { d: "M21 17H14V19H21V17Z", fill: "currentColor" }),
            React.createElement("path", { d: "M3 14V9H5V14H9.08579L7.79291 12.7071L9.20712 11.2929L12.9142 15L9.20712 18.7071L7.79291 17.2929L9.08582 16H5C3.89543 16 3 15.1046 3 14Z", fill: "currentColor" }))));
});
//# sourceMappingURL=ListArrowDownRight.js.map